import Head from 'next/head'
import { Component, ErrorInfo, ReactNode } from 'react'
import dynamic from 'next/dynamic'

const InternalError = dynamic(() => import('@components/pages/500'), {
  ssr: false,
})
import { PageContainer } from '@styled_components/404/styled.components'
import Footer from '@components/organisms/FooterNew'
import { Spacer } from '@nextui-org/react-latest'

import { EdugramIconNew } from '@public/static/icons/edugramIcon'
import { customStore } from '@utils/storage'
import { del } from 'idb-keyval'

interface ErrorBoundaryProps {
  children: ReactNode
  title?: string
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
  showError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null, showError: true }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error, showError: false }
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo): Promise<void> {
    console.error('Error caught by error boundary:', error, errorInfo)
    console.log(this.state.hasError)
    if (this.state.hasError) {
      const Sentry = await import('@sentry/browser')
      Sentry.captureException(error)
    }
  }

  componentDidMount(): void {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.keyCode === 83) {
        this.setState((prevState) => ({
          showError: !prevState.showError,
        }))
      }
    }
    // setTimeout(() => {
    //   this.setState({
    //     hasError: true,
    //     error: new Error('Simulated Error after 5 seconds'),
    //   })
    // }, 5000)

    document.addEventListener('keydown', handleKeyDown)
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <>
          <Head>
            <title>{this.props.title || ''}</title>
          </Head>
          <div className="p-4 flex justify-center">
            <button
              aria-label="Edugram Inc."
              onClick={() => {
                del('REACT_QUERY_OFFLINE_CACHE', customStore)
                window.location.href = '/courses'
              }}
            >
              <EdugramIconNew />
            </button>
          </div>
          {/* <Layout> */}
          <div className="my-36 mt-20 md:my-36">
            <PageContainer>
              <div className="flex flex-col">
                <InternalError />
                {this.state.showError && (
                  <p className="text-base text-center">
                    {this.state.error?.toString()}
                  </p>
                )}
              </div>
            </PageContainer>
          </div>
          <Spacer y={24} />
          <Footer />
          {/* </Layout> */}
        </>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
